import { BASE_URL } from "constants/routes";
import { encryptPayload } from "./encrypt";
import { createAsyncThunk } from "@reduxjs/toolkit";

/**
 ** This function makes a call to BE to fetch the configuration for bulk workflow and sets that in redux
 *  @params {params} is an object with 1 mandatory properties and rest can be optional
 *  @property {configuration_id}
 */
export const getBulkWorkflowConfiguration = createAsyncThunk("fetchApi/configuration", async (id,{ dispatch }) => {
  const req = `${BASE_URL}/bulkWorkflow/getBulkWorkflowConfigurationById`
  let params = {
    body: {_id: id}
  }
  const encryptedBodyRes = await encryptPayload("",params,true,true)
  const options = {
    method: 'POST',
    body: JSON.stringify(encryptedBodyRes),
    headers: {
      "Content-Type": "application/json"
    },
  }
  
  try {
    const result = await encryptPayload(req, options, false, true,true);
    return result.data;
  }
  catch (err) {
        console.log(err);
        return {
          status: "failed",
          message: err?.message,
          error: err,
        };
      }
})

/**
 * Handles the upload of a ZIP file to a server endpoint with optional encryption of parameters.
 * 
 * This function performs the following tasks:
 * 1. Validates the file type to ensure it's a ZIP file.
 * 2. Constructs a `FormData` object to send the ZIP file in a `POST` request.
 * 3. Optionally encrypts any additional parameters before including them in the request.
 * 4. Sends the `POST` request to the server with the ZIP file and encrypted parameters (if any).
 * 5. Handles any errors that occur during the file upload or parameter encryption process.
 * 
 * @param {File} file - The ZIP file to be uploaded.
 * @param {Object} [params] - Optional parameters that may be encrypted before uploading.
 * @returns {Promise<Object>} The server response if the upload is successful.
 * @throws {Error} Throws an error if the file is not a ZIP file or if any part of the process fails.
 */
export const handleZipFileUpload = async (file, params) => {
  const req = `${BASE_URL}/bulkWorkflow/handleZipFileUpload`;
  if (file.type !== 'application/zip') {
    throw new Error('Please upload a valid ZIP file.');
  }
  const formData = new FormData();
  formData.append("file", file); // Append the ZIP file

  // Encrypt params if provided
  if (params) {
    try {
      const encryptedParams = await encryptPayload('', { body: params }, true, true);
      formData.append("data", JSON.stringify(encryptedParams)); 
    } catch (err) {
      console.error("Error encrypting parameters:", err);
      throw new Error("Failed to encrypt parameters");
    }
  }
  try {
    const options = {
      method: 'POST',
      body: formData,
    };
    let response = await encryptPayload(req, options, false, true);
    if (response.status === "failed") {
      const errorData = await response.text(); 
      console.error("Error response data:", errorData);
      throw new Error(response.message || 'Upload failed');
    }
    return response;
  } catch (err) {
    console.error("Error uploading ZIP file:", err);
    throw err; 
  }
};

